import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/modern/applications/marketplace-modern/src/app/global-error.tsx");
